<template>
  <div >
    <el-drawer
  title="我是标题"
  :visible.sync="drawersearch"
  direction="ttb"
  :before-close="handleClose">
  <section class="header__search white-bg transition-3 search-opened">
            <div class="container">
                <div class="row">
                    <div class="col-xl-12">
                        <div class="header__search-inner text-center">
                            <form action="#">
                                <div class="header__search-btn">
                                    <a href="javascript:void(0);" class="header__search-btn-close"><i class="fal el-icon-close"></i></a>
                                </div>
                                <div class="header__search-header">
                                    <h3>Search</h3>
                                </div>
                                <!-- <div class="header__search-categories">
                                    <ul class="search-category">
                                        <li><a class="pointer">All Categories</a></li>
                                        <li><a >Accessories</a></li>
                                        <li><a >Chair</a></li>
                                        <li><a >Tablet</a></li>
                                        <li><a >Men</a></li>
                                        <li><a >Women</a></li>
                                        
                                    </ul>
                                </div> -->
                                <div class="header__search-input p-relative">
                                    <input type="text" placeholder="Search for products... ">
                                    <button type="submit"><i class="fa fa-search"></i></button>
                                </div>
                            </form>
                
                            
                        </div>
                    </div>
                </div>
            </div>
        </section>
</el-drawer>
    
    <!-- header area start -->
        <header>
        
            <div id="header-sticky" ref="backTop" class="header__area grey-bg " :class="fixedmenu?'sticky':''">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 hidden-xs-only">
                            <div class="logo" :class="logourlshop?'logourl':''">
                                <a href="index.html">
                                  <img v-if="logourlshop" :src="allurl +logourlshop" alt="logo1">
                                  <img v-else src="../assets/img/logo/logo.png" alt="logo1">
                                </a> 
                            </div>
                        </div>
                        <div class="col-xl-9 col-lg-9 col-md-8 col-sm-8">
                            <div class="header__right p-relative d-flex justify-content-end align-items-center">
                                <div class="main-menu d-none d-lg-block">
                                    <nav>
                                        <ul>
                                            <li class="active "><a  @click="urlto(1)">Home <p>首页</p></a>
                                               
                                            </li>
                                            <li class="mega-menu has-dropdown" ><a @click="urlto(2)">Products <p>严选优品</p><i  class="el-icon-arrow-down"></i></a>
                                                <ul class="submenu transition-3 hidden-md-and-down" v-if="goodstype" style="background-image: url('/static/img/bg/bg222.png');">
                                                    
                                                 
                                                          <div class="banner__inner " >
                                                              <div class="row flex-sb towmenucolor" >
                                                                  <div class="col-xl-2 towmenuleft">  
                                                                          <h2>
                                                                             <a>shop <br /></a>
                                                                            <p style="color:#1A1B1D">Premium products </p> 
                                                                          </h2>
                                                                          <a class="link-btn">特&nbsp;&nbsp;选&nbsp;&nbsp;优&nbsp;&nbsp;品</a>
                                                                  </div>
                                                                  <div class="col-xl-10 " style="display: flex;-ms-flex-wrap: wrap;flex-wrap: wrap;">
                                                                      <div class=" col-xl-4 col-lg-4 col-md-6 col-xs-6"   v-for="(item, index) in goodstype" :key="index">
                                                                        <div class="towmenu banner__item p-relative mb-30" >
                                                                          <div class="banner__thumb fix">
                                                                              <!--  <a class="w-img">
                                                                                 <img src="../../assets/img/shop/banner/kitchen.png" class="p-absolute" alt="banner"> 
                                                                              </a>-->
                                                                          </div>
                                                                          <div class="transition-3">
                                                                              <h5 style="margin-bottom:0">
                                                                                  <a>{{ item.ex_title }} <br />
                                                                                      <span>{{ item.title }}</span> 
                                                                                  </a>
                                                                                   
                                                                              </h5>
                                                                              <div class="flex flex-sb" style="    flex-flow: column;">
                                                                                  <!-- <a class="link-btn">Discover now</a> -->
                                                                                  <!-- <div style="width:45%"> <el-button plain type="warning" round size="mini">Discover now</el-button></div> -->
                                                                                  <div style="width:fit-content" @click="goshop(item.id,index+1)">
                                                                                      <a class="link-btn">Discover now</a>
                                                                                  </div>
                                                                                  <div style="width: 100%;pisition:relative;">
                                                                                      <img style="width: 40%;float:right" :src="allurl + item.image"
                                                                                          :alt="item.ex_title" />
                                                                                  </div>
                                                                              </div>
                                                                              <!-- <a class="link-btn">Discover now</a> -->
                                                                          </div>
                                                                      </div>
                                                                  </div>
                                                                </div>    
                                                              </div>
                                                          </div>
                                                      
                                                  <!-- banner area end -->
                                                </ul>
                                            </li>
                                            <li class="" ><a @click="urlto(3)">About<p>关于我们</p></a>
                                               
                                            </li>
                                            <li class="" ><a @click="showIntroduce()">Brands<p>品牌推介</p></a>
                                                <ul class="submenu transition-3" v-show="showintro">
                                                     <li><a target=_blank href="http://granaryi.com.au">Yumaotong</a></li>
                                                   
                                                </ul>
                                            </li>
                                            <li ><a @click="urlto(5)">Contact<p>联系我们</p></a></li>
                                             <li class="" ><a   @click="urlto(7)">Our Services<p>我们的服务</p></a></li>
                                        </ul>
                                    </nav>
                                </div>
                                <div class="mobile-menu-btn d-lg-none">
                                    <a  class="mobile-menu-toggle hidden-xs-only"><i @click="drawer=true" class="fa fa-bars"></i></a>
                                    <div class="logo hidden-sm-and-up " :class="logourlshop?'logourl':''">
                                        <a href="index.html">
                                          <img v-if="logourlshop" :src="allurl +logourlshop" style="max-width:100px" alt="logo22">
                                          <img v-else src="../assets/img/logo/logo.png" style="width:70px" alt="logo22">
                                        </a>
                                        
                                    </div>
                                </div>
                                <div class="header__action">
                                    <ul>
                                        <li><a  @click="drawersearch = true" class="search-toggle"><i class="fa fa-search" style="font-size:20px;color:#292a30"></i> Search</a></li>
                                        <li >
                                            <a @click="urlto(6)" class="point cart"><i class="ion-bag">
                                              <img src="../assets/img/bg/cart.png" />
                                              <span style="position:absolute;font-size:12px;right:-10px;background: #DCB54D;border-radius:50%;line-height: 18px;top: 10px;padding: 0 5px">{{allcartnum?allcartnum:cartnum}}</span></i> &nbsp;&nbsp;&nbsp;Cart 
                                            </a>
                                            <ul class="mini-cart">
                                                <li   v-for="(item, index) in nowcartlist" :key="index">
                                                  <div  v-if="nowcartlist">
                                                     <div class="cart-img f-left">
                                                        <a>
                                                            <img :src="allurl+item.thumb" alt="" />
                                                        </a>
                                                    </div>
                                                    <div class="cart-content f-left text-left">
                                                        <h5>
                                                            <a>Consectetur adi </a>
                                                        </h5>
                                                        <div class="cart-price">
                                                            <span class="ammount">{{item.num}} <i class="fa fa-times"></i></span>
                                                            <span class="price">$ {{item.money}}</span>
                                                        </div>
                                                    </div>
                                                    <div class="del-icon f-right mt-30">
                                                        <a >
                                                          <!-- fa fa-times -->
                                                            <i class="">${{item.money*item.num}}</i>
                                                        </a>
                                                    </div>
                                                  </div>
                                                    
                                                </li>
                                                <li v-if="nowcartlist">
                                                    <div class="total-price">
                                                        <span class="f-left">Subtotal:</span>
                                                        <span class="f-right">${{allmoney}}</span>
                                                    </div>
                                                </li>
                                                <li v-if="!nowcartlist" class="total-price">购物车暂无商品</li>
                                                <li>
                                                    <div class="checkout-link">
                                                        <a @click="urlto(6)" class="os-btn point">view Cart</a>
                                                        <!-- <a class="os-btn os-btn-black" href="checkout.html">Checkout</a> -->
                                                    </div>
                                                </li>
                                            </ul>
                                        </li>
                                        <!-- <li> <a href="javascript:void(0);"><i class="far fa-bars"></i></a>
                                            <ul class="extra-info">
                                                <li>
                                                    <div class="my-account">
                                                        <div class="extra-title">
                                                            <h5>My Account</h5>
                                                        </div>
                                                        <ul>
                                                            <li><a href="login.html">My Account</a></li>
                                                            <li><a href="wishlist.html">Wishlist</a></li>
                                                            <li><a href="cart.html">Cart</a></li>
                                                            <li><a href="checkout.html">Checkout</a></li>
                                                            <li><a href="register.html">Create Account</a></li>
                                                        </ul>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="lang">
                                                        <div class="extra-title">
                                                            <h5>Language</h5>
                                                        </div>
                                                        <ul>
                                                            <li><a >English</a></li>
                                                            <li><a >France</a></li>
                                                            <li><a >Germany</a></li>
                                                            <li><a >Bangla</a></li>
                                                        </ul>
                                                    </div>
                                                </li>
                                                <li>
                                                    <div class="currency">
                                                        <div class="extra-title">
                                                            <h5>currency</h5>
                                                        </div>
                                                        <ul>
                                                            <li><a >USD - US Dollar</a></li>
                                                            <li><a >EUR - Ruro</a></li>
                                                            <li><a >GBP - Britis Pound</a></li>
                                                            <li><a >INR - Indian Rupee</a></li>
                                                        </ul>
                                                    </div>
                                                </li>
                                            </ul>
                                        </li> -->
                                    </ul>
                                     
                                </div>
                                <div class=" hidden-sm-and-up">
                                  <a  class="mobile-menu-toggle"><i @click="drawer=true" class="fa fa-bars"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <!-- header area end -->
         <!-- search area start -->
        <section class="header__search white-bg transition-3">
            <div class="container">
                <div class="row">
                    <div class="col-xl-12">
                        <div class="header__search-inner text-center">
                            <form action="#">
                                <div class="header__search-btn">
                                    <a href="javascript:void(0);" class="header__search-btn-close"><i class="fal fa-times"></i></a>
                                </div>
                                <div class="header__search-header">
                                    <h3>Search</h3>
                                </div>
                                <!-- <div class="header__search-categories">
                                    <ul class="search-category">
                                        <li><a href="shop.html">All Categories</a></li>
                                        <li><a href="shop.html">Accessories</a></li>
                                        <li><a href="shop.html">Chair</a></li>
                                        <li><a href="shop.html">Tablet</a></li>
                                        <li><a href="shop.html">Men</a></li>
                                        <li><a href="shop.html">Women</a></li>
                                        
                                    </ul>
                                </div> -->
                                <div class="header__search-input p-relative">
                                    <input type="text" placeholder="Search for products... ">
                                    <button type="submit"><i class="far fa-search"></i></button>
                                </div>
                            </form>
                
                            
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div class="body-overlay transition-3"></div>
         <!-- scroll up area start -->
         <el-backtop  >
            <div class="scroll-up " id="scroll" >
              <a class="scrollx" @click="gocart" href="javascript:void(0);"><p style="" class=""><img style="width:50%" src="../assets/img/bg/cartw.png" alt=""></p><p>（{{allcartnum?allcartnum:cartnum}}）</p></a>
               <a href="javascript:void(0);"><i class="fa fa-level-up"></i></a> 
               
               
            </div>
            <!-- <div class="scroll-up" id="scroll" >
                <a href="javascript:void(0);"><i class="fa fa-level-up"></i></a>
            </div> -->
          </el-backtop>
         <div class="scroll-up scrollback " v-if="backlock" id="scrollback" >
             <a @click="backgo"><img  src="../assets/img/bg/back.png" alt=""></a> 
              
           </div>
        <!-- scroll up area end -->

       

        <!-- extra info area start -->
        <el-drawer
        size="80%"
          :visible.sync="drawer"
          direction="rtl"
          >
          
                <!-- side-mobile-menu start -->
                <nav class="side-mobile-menu d-block d-lg-none">
                    <ul id="mobile-menu-active">
                        <li @click="urlto(1)" class="active "><a  >HOME <p>首页</p></a></li>
                        <li @click="urlto(2)" class="" ><a >PRODUCTS<p>严选优品</p></a></li>
                        <li @click="urlto(3)" class="" ><a >ABOUT<p>关于我们</p></a></li>
                        <li @click="showIntroduce()" class="" ><a >BRANDS<p>品牌推介</p>
                          <ul class="submenu transition-3" style="border-top:1px solid #ccc" v-show="showintro" >
                              <li><a target=_blank href="http://granaryi.com.au" >Yumaotong</a></li>
                              <!-- <li><a href="index-2.html">Home Style 2</a></li> -->
                              
                          </ul> 
                        </a>
                            
                        </li>
                        <li @click="urlto(5)" class="" ><a >CONTACT<p>联系我们</p></a></li>
                        <li @click="urlto(7)" class="" ><a >OUR SERVICES<p>我们的服务</p></a></li>
                        <li v-if="login" @click="loginout" class="" ><a >logout<p>登出</p></a></li>
                        <li v-if="!login" @click="loginnew" class="" ><a >login<p>登录</p></a></li>
                    </ul>
                </nav>
                <!-- side-mobile-menu end -->
            
        </el-drawer>
        
        <!-- search area end -->
         <!-- prealoder area end -->

        
       
       
        <div class="body-overlay transition-3"></div>
        <!-- extra info area end -->
    <!-- <div class="mask" v-if="mask" @click="closewindow"></div> -->
  </div>
</template>
<script>
import { getindex } from "@/api/index/index";
// import '/element-ui/lib/theme-chalk/display.css';
export default {
  name: "header",
  props:['index','allcartnum'],
  data() {
    return {
      mask: false,
      msgshow: false,
      allmoney: 0,
      allnum:0,
      logourl: "",
      shopshow: false,
      goodstype:[],
      drawershop: false,
      dialogVisible: false,
      config: [],
      indexactive: "",
      activeIndex: "1",
      activeIndex2: "1",
      cartnum:0,
      logourlold:'../assets/img/logo/logo.png',
      logourlshop:'',
      drawersearch: false, //1
      drawer: false, //1
      fixedmenu:false,
      nowcartlist:[],
      cartnone:false,
      backlock:true,
      login:false,//判断登录
      showintro:false,
      // direction: 'rtl',//1导航抽屉
      // activeIndex: "",
    };
  },

  // created(){
  //   this.activeIndex = this.index;
  // },
  mounted() {
    if (sessionStorage.getItem("login")){
        this.login=true
    }else{
      this.login=false
    }
    //console.log(this.index)
    if(this.index==100){
      this.backlock=false
    }
    //console.log(this.allcartnum)
    this.getlogo();
    this.getcof(); 
    window.addEventListener('scroll', this.handleScroll, true) 
    // //console.log("索引为", this.index, "进来+1");
    this.activeIndex = this.index;
    // //console.log(this.activeIndex, "进来activeIndex1");
    //  debugger
  },
  onshow() {
    this.getcof(); 
  },
  destroyed() {
    window.removeEventListener("scroll",  this.handleScroll);
  },
  methods: {
    getlogo() {
      if(sessionStorage.getItem("cart")||sessionStorage.getItem("cart")!=''){
        console.log(sessionStorage.getItem("cart"));
        this.nowcartlist = JSON.parse(sessionStorage.getItem("cart"));
      }
      console.log(12233);
      if(!this.nowcartlist){
        this.cartnone=false
      }else{
         this.cartnone=true
      }
      this.getallnum();
    },
    getallnum() {
      var allsnum = 0;
      var allsmoney = 0;
      var lock = false;
      if (this.nowcartlist) {
        this.nowcartlist.forEach((item) => {
          allsmoney += item.num * item.money;
          allsnum += item.num;
          lock = true;
          //console.log(item.num, "num");
        });
        if (lock) {
          this.allnum = allsnum;
          this.allmoney = allsmoney;
        }
      }
    },
    showIntroduce(){
      this.showintro=!this.showintro
    },
    handleScroll() {  
      // //console.log('滚动高度', window.pageYOffset)  
      // //console.log('距离顶部高度', this.$refs.backTop.getBoundingClientRect().top)  
      if(window.pageYOffset>111){
        this.fixedmenu=true
      }else{
        this.fixedmenu=false
      }
    },
    goindex(){
      this.$router.push({ name: "home" });
    },

    gocart(){
      this.$router.push({ name: "cart" });
    },
    goshop(id,index){
      this.$router.push({ path: "/shop", query: { id } });//这里 

      this.$emit('change',id)// 向父组件传递了个值 
    }, 
    handleSelect(key, keyPath) {
      //console.log(key, keyPath);
    },
    urlto(urlnum) {
      // //console.log(urlnum, "栏目索引");
      // //console.log(this.activeIndex, "栏目索引");
      // //console.log(urlnum, "点其他");
        switch (urlnum) {
          case 1:
            this.$router.push({ path: "/" }); 
            break;
          case 2:
            this.$router.push({ path: "/shop",query: { id:0 } });
            this.$emit('change',0)
            break;
          case 3:
            this.$router.push({ name: "about" });
            break;
          case 4:
            this.$router.push({ name: "news" });
            break;
          case 5:
            //console.log(1231244)
            this.$router.push({ name: "team" });
            break;
          case 6:
            this.$router.push({ name: "cart" });
            break;
          case 7:
            this.$router.push({ name: "service" });
            break;
          default:
            return;
        }
      
    },
    msg(data) {
      this.dialogVisible = true;
      // this.msgshow = true;
      // this.mask = true;
      //   <div class="pop_service" v-if="msgshow">
      //   <div class="close" @click="closewindow"></div>
      //   <h1 class="s_tit">Service</h1>
      //   <div class="con">
      //     <p>服务热线</p>
      //     <p>400-060-1992</p>
    },
    getcof() {
      //  this.allcartnum=sessionStorage.getItem('cartnum') 
       console.log(123)
      getindex().then((res) => {
        this.goodstype = res.goodstype;
      })
      if (sessionStorage.getItem("logourlshop") != "" && sessionStorage.getItem("logourlshop") != null) {
        //console.log(sessionStorage.getItem("logourlshop"),'缓存有头像')
        this.logourlshop = sessionStorage.getItem("logourlshop");
      }
      if(JSON.parse(sessionStorage.getItem('cart'))){
        var cartnum=JSON.parse(sessionStorage.getItem('cart')).length
        sessionStorage.setItem('cartnum',cartnum)
        this.cartnum= sessionStorage.getItem('cartnum')
      }else{
        this.cartnum=0
      }
      

     
      // getconfig().then((res) => {
      //   this.config = res.data;
      //   localStorage.setItem("logourl", this.config.logo);
      // });
    },
    // 登出
    loginout(){
        sessionStorage.setItem('login','')
        sessionStorage.setItem('logourlshop','')
        sessionStorage.setItem('concact','')    
        sessionStorage.setItem('shopid','') 
        location. reload()
    },
    loginnew(){
      this.$router.push({ name: "login" });
    },
    shopClose(done) {
      //console.log(123123);
      done();
    },
    shop(data) {
      this.shopshow = true;
      this.mask = true;
    },
    closewindow() {
      this.msgshow = false;
      this.drawershop = false;
      this.mask = false;
    },
    opendr() {
      //console.log(1112);
    },
    closeDrawer() {
      //console.log(1);
      done();
    },
    handleClose(done) {
      //console.log(123123);
      done();
    },

    handleSelect(key) {
      // switch (key) {
      //   case "1":
      //     this.$router.push("/");
      //     break;
      //   case "2":
      //     this.$router.push("/news");
      //     break;
      //   case "3":
      //     this.$router.push("/service");
      //     break;
      //   case "4":
      //     this.$router.push("/curriculum");
      //     break;
      //   case "5":
      //     this.$router.push("/teacher");
      //     break;
      // }
    },
    goLogin() {
      window.open("https://www.mayuwl.com/"); // 打开登录
    },
    backgo(){
      this.$router.go(-1)
    }
  },
};
</script>

<style>

     /* @import "../assets/css/preloader.css";
    @import "../assets/css/bootstrap.min.css";
    @import "../assets/css/slick.css";
    @import "../assets/css/owl.carousel.min.css";
    @import "../assets/css/animate.min.css";
    @import "../assets/css/jquery.fancybox.min.css";
    
    @import "../assets/css/default.css";
    @import "../assets/css/style.css"; */
.el-menu-demo .el-menu-item {
  font-size: 20px;
  /* padding: 0 10px; */
  font-weight: bold;
    height: 50px;
    line-height: 50px;
}
.banner .img {
  height: 400px;
  overflow: hidden;
  width: 100%;
}
.indexb .img {
  height: inherit;
  max-height: 90vh;
}
.wrapper {
  margin-top: 130px;
}
.shopBag .btn_wrap {
  text-align: left;
}
.shopBag .btn_wrap + .btn_wrap {
  margin-top: 25px;
}
.pop_service .btn_wrap {
  margin-top: 45px;
}
.btn_wrap.bai .btn_zx {
  margin: 0;
  color: #000;
  border: 1px solid #000;
}
.btn_wrap.bai .btn_zx:hover {
  background: #000;
  color: #fff;
}
.shopBag .con_wrap {
  margin-top: 30px;
  margin-bottom: 85px;
  font-size: 16px;
  color: #808080;
}
.shopBag .con_wrap h1 {
  margin-bottom: 40px;
}
.shopBag .con_wrap p {
  margin-bottom: 20px;
}
.shopBag .btn_wrap {
  text-align: left;
}
.shopBag .btn_wrap + .btn_wrap {
  margin-top: 25px;
}

.btn_wrap {
  display: block;
  text-align: center;
}
.drop_more {
  margin-top: 40px;
}
.btn_wrap .btn_zx {
  display: inline-block;
  width: 270px;
  height: 40px;
  font-size: 18px;
  margin: 0 auto;
  line-height: 40px;
  text-align: center;
  color: #000;
  background: #fff;
  text-decoration: none;
  cursor: pointer;
}
.btn_wrap .btn_zx:hover {
  background: #c3b79b;
  color: #fff;
  text-decoration: none;
}
.btn_wrap.bai .btn_zx {
  margin: 0;
  color: #000;
  border: 1px solid #000;
}
.btn_wrap.bai .btn_zx:hover {
  background: #000;
  color: #fff;
}
.btn_wrap.hei.more .btn_zx {
  display: inline-block;
  vertical-align: middle;
  /*i{
          width:;
          display: inline-block;
        }*/
}
.btn_wrap.hei .btn_zx {
  margin: 0;
  color: #fff;
  border: 1px solid #000;
  background: #000;
}
.btn_wrap.hei .btn_zx:hover {
  background: #fff;
  color: #000;
}
.mask {
  z-index: 999;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  /* display: none; */
}

.header {
  position: relative;
}
.header .logo {
  width: 150px;
  height: 59px;
  /* background: url("../../public/image/logoindex.png") no-repeat center; */
  background-size: contain;
  margin: 0 auto;
}
.header .logo img {
  width: 100%;
  height: 100%;
}
/* .header .logo a {
  display: block;
  width: 100%;
  height: 42px;
} */
.header .icon {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  display: block;
  cursor: pointer;
}
.header .icon + .icon {
  margin-left: 25px;
}
 .icon_menu,
 .right_icon {
  /* position: absolute; */
  height: 42px;
  top: 0;
}
 .icon_menu {
  width: 42px;
  right: 0;
  height:42px;
  cursor: pointer;
  background-image: url("../../public/image/menu.png");
}
.header .right_icon {
  /* left: 0; */
}
.header .right_icon .icon {
  width: 42px;
  height: 42px;
  float: left;
}
.header .right_icon .icon_msg {
  background-image: url("../../public/image/message.png");
}
.header .right_icon .icon_bag {
  background-image: url("../../public/image/bag.png");
}

.dl_con_wrap {
  transition: transform 0.3s linear;
  background: #fff;
  /* position: fixed; */
  z-index: 1000;
  width: 100%;
  overflow: auto;
  padding: 0 8% 0;
  height: 100%;
  top: 0;
  padding-top: 50px;
}
.dl_con_wrap.sliding-menu {
  transform: translateX(0%);
  left: 0;
}
.dl_con_wrap.shopBag {
  /* transform: translateX(100%);
  */
  right: 0;
}
.dl_con_wrap.on {
  transform: translateX(0%);
}
.dl_con_wrap a {
  border: 0;
  outline: none;
  text-decoration: none;
  color: #000;
}
.dl_con_wrap a:hover {
  border: 0;
  outline: none;
  text-decoration: none;
}
.dl_con_wrap a.back {
  padding-left: 30px;
  padding-right: 30px;
  font-size: 32px;
  line-height: 56px;
  padding-top: 0;
  padding-bottom: 0;
  margin-bottom: 8px;
  color: #000;
  display: block;
}
.dl_con_wrap a.back.i-right {
  margin-left: -30px;
}
.dl_con_wrap a.back.i-right:before {
  right: 0;
  left: auto;
  background-position: center right;
}
.dl_con_wrap a.back:before {
  display: inline-block;
  content: "";
  width: 30px;
  height: 100%;
  transform: none;
  position: absolute;
  top: 0;
  left: 0px;
  background-repeat: no-repeat;
  background-position: center left;
  background-image: url("../../public/image/nav_icon_close.png");
}

.sliding-menu {
  overflow: hidden;
  font-size: 16px;
  line-height: 1.5em;
}
.sliding-menu ul {
  margin: 0;
  background: #fff;
}
.sliding-menu ul li {
  padding: 18px 0;
}
.sliding-menu ul li.hassub > a {
  position: relative;
}
.sliding-menu ul li.hassub > a:after {
  content: "";
  display: block;
  position: absolute;
  right: 0;
  top: 0;
  width: 24px;
  height: 100%;
  background: url("../../public/image/nav_icon_arrow_right.png") no-repeat
    center;
}
.sliding-menu ul li.hassub.on .menu-panel {
  display: block;
}
.sliding-menu ul li.hassub.on > a {
  position: relative;
}
.sliding-menu ul li.hassub.on > a:after {
  transform: rotate(90deg);
}
.sliding-menu a {
  display: block;
  position: relative;
}
.sliding-menu a.nav:before {
  display: inline-block;
  content: "";
  width: 6px;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url("../../public/image/nav_icon_arrow_right.png");
  background-size: contain;
}
.sliding-menu .menu-panel {
  display: none;
  padding-left: 20px;
}
.sliding-menu .menu-panel a {
  color: #9b9b9b;
}
.sliding-menu .menu-panel a:hover {
  color: #000;
}
.sliding-menu .menu-panel li {
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.flex-jc {
  justify-content: center;
}
.flex-sb {
  justify-content: space-between;
}
.sliding-menu .menu-panel li a {
  font-size: 14px;
  width: 30%;
  margin-top: 15px;
}
a, button {
    color: inherit;
    outline: none;
    border: none;
}
.h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6 {
    margin-bottom: 0.5rem;
    font-weight: 500;
    line-height: 1.2;
}
* {
  padding: 0;
  margin: 0;
  font-weight: normal;
  list-style: none;
  line-height: inherit;
  text-decoration: none;
  font-size: inherit;
  font-style: normal;
  position: relative;
  border: none;
  outline: none;
  border: 0;
  outline: 0;
  font-family: "Poppins", sans-serif;
  background: none;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  /* -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none; */
  /* user-select: none; */
}
/* *:hover,
*:focus {
  border: none;
  outline: none;
} */
#header {
  width: 100%;
  /* padding: 2% 3%; */
  background: #fff;
  font-family: "Times New Roman";
}
#header a {
  text-decoration: none;
}
#header a:hover {
  text-decoration: none;
}
#header.fixed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2100;
  /* padding: 30px 0; */
  /* margin-bottom: 100px; */
}
#header.fixed .header {
  width: 94%;
  margin: 0 auto;
}
.mobile-menu-active p{margin-bottom: 0;}

.bg12 {
  max-width: 94%;
  margin: 0 auto;
  /* min-width: 1200px; */
}
.bg12 .img img {
  width: 100%;
}
.pop_service {
  /* display: block;
  position: fixed;  
  z-index: 1000;
  background: #fff;
  left: 50%;
  top: 50%;
  width: 630px;
  transform: translateY(-50%) translateX(-50%); */
  text-align: center;
  /* padding: 45px 25px 55px; */
  letter-spacing: 3px;
}
.pop_service .close {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 30px;
  height: 30px;
  background: url("../../public/image/icon_close.png") no-repeat center;
  background-size: auto;
  cursor: pointer;
}
.pop_service .s_tit {
  font-size: 36px;
  color: #2e2e2e;
  margin-bottom: 45px;
}
.pop_service .con {
  color: #9a9a9a;
}
.pop_service .con p {
  font-size: 16px;
  line-height: 1em;
  margin-bottom: 20px;
}
.pop_service .con + .con {
  margin-top: 40px;
}
.pop_service .btn_wrap {
  margin-top: 45px;
}
.icon_go_wrap {
  position: fixed;
  right: 3%;
  z-index: 1000;
  bottom: 10%;
}
.rightnav {
  width: 90px;
}
@media screen and (max-width: 480px) {
  .btn_wrap .btn_zx {
    width: auto;
    padding: 0 10px;
  }
  .header__right.justify-content-end{
    justify-content: space-between!important;
  }
  .btn_wrap.hei .btn_zx {
    width: auto;
    padding: 0 10px;
  }
  .el-dialog {
    width: 70% ;
  }
  .wrapper {
    margin-top: 130px !important;
  }
  .con_wrap.item2 {
    padding: 0 !important;
  }
  section img {
    width: 100%;
  }
  .rightnav {
    width: initial;
  }
}
/*    ------------------------------- */
.container,
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  /* width: 100%; */
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container,
  .container-sm {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container,
  .container-md,
  .container-sm {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
 
  .container,
  .container-lg,
  .container-md,
  .container-sm {
      width: 100%;
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl {
    
    max-width: 1140px;
  }
}
.container,
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  /* width: 100%; */
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.main-menu ul li:hover>a>p{
    color: #bc8246 !important;
}
.main-menu ul li:hover>a{
    color: #bc8246 !important;
}
.submenu:hover~.has-dropdown{
color: #bc8246 !important;
}
/* .main-menu ul li p:hover {
    color: #bc8246 !important;
} */
.mini-cart {
    position: absolute;
    right: 0!important;
    top: 100%;
    background: #ffffff;
    padding: 25px;
    width: 350px;
    z-index: 9;
    border: 1px solid #e1e1e1;
    -webkit-box-shadow: 0px 15px 30px 0px rgb(0 3 143 / 10%);
    -moz-box-shadow: 0px 15px 30px 0px rgba(0, 3, 143, 0.1);
    box-shadow: 0px 15px 30px 0px rgb(0 3 143 / 10%);
    visibility: hidden;
    opacity: 0;
    -webkit-transition: all 0.3s ease-out 0s;
    -moz-transition: all 0.3s ease-out 0s;
    -ms-transition: all 0.3s ease-out 0s;
    -o-transition: all 0.3s ease-out 0s;
    transition: all 0.3s ease-out 0s;
}

.rightcart ul li:hover .mini-cart {
    visibility: visible;
    opacity: 1; 
} 
#header .rightcart ul li:hover .extra-info {
    visibility: visible;
    opacity: 1;
}
#header .rightcart ul li .extra-info {
    position: absolute;
    top: 100%;
    right: 0;
    background-color: #ffffff;
    padding: 20px;
    margin: 0;
    min-width: 220px;
    padding-bottom: 5px;
    border: 1px solid #e1e1e1;
    z-index: 9;
    max-height: 400px;
    overflow: auto;
    visibility: hidden;
    opacity: 0;
    -webkit-transition: all 0.3s ease-out 0s;
    -moz-transition: all 0.3s ease-out 0s;
    -ms-transition: all 0.3s ease-out 0s;
    -o-transition: all 0.3s ease-out 0s;
    transition: all 0.3s ease-out 0s;
}
#header .rightcart ul li .extra-info li {
    display: block;
    margin-left: 0;
    margin-bottom: 10px;
}
#header .rightcart ul li {
    display: inline-block;
    position: relative;
    margin-left: 25px;
}

#header .rightcart ul li .extra-info .extra-title h5 {
    font-size: 14px;
    color: #323232;
    margin: 15px 0 10px;
    text-transform: capitalize;
}
h5 {
    font-size: 16px;
}
#header .rightcart ul li .extra-info li ul li {
    margin-bottom: 0;
}
#header .rightcart ul li .extra-info li {
    display: block;
    margin-left: 0;
    margin-bottom: 10px;
}

.rightcart ul li:hover > a {
    color: #323232;
}
.rightcart ul li > a {
    color: #444;
    position: relative;
    display: inline-block;
    padding: 27px 0;
    cursor: pointer;
    padding-bottom: 30px;
}

.rightcart ul li > a i {
    color: #323232;
    margin-right: 3px;
    font-size:18px 
    }

 .rightcart .mini-cart{
   position: absolute;
    right: 0;
    top: 100%;
    background: #ffffff;
    padding: 25px;
    width: 350px;
    z-index: 9;
    border: 1px solid #e1e1e1;
    -webkit-box-shadow: 0px 15px 30px 0px rgb(0 3 143 / 10%);
    -moz-box-shadow: 0px 15px 30px 0px rgba(0, 3, 143, 0.1);
    box-shadow: 0px 15px 30px 0px rgb(0 3 143 / 10%);
    visibility: hidden;
    opacity: 0;
    -webkit-transition: all 0.3s ease-out 0s;
    -moz-transition: all 0.3s ease-out 0s;
    -ms-transition: all 0.3s ease-out 0s;
    -o-transition: all 0.3s ease-out 0s;
    transition: all 0.3s ease-out 0s;
}
  .el-backtop{background-color:transparent;box-shadow: none;z-index: 101;}
  .el-backtop:hover {
    background-color: transparent;
}
  .mini-cart li {
    display: block!important;
    margin-bottom: 30px;
    margin-left: 0;
    overflow: hidden;
    padding: 0;
}
.mini-cart li .cart-img {
    margin-right: 15px;
}
.mini-cart li .cart-img a img {
    width: 75px;
}
.mini-cart li .cart-content {
    margin-top: 5px;
}
.mini-cart li .cart-content h5 {
    font-size: 13px;
    font-weight: 500;
}
.mini-cart li .total-price {
    padding-top: 22px;
    border-top: 1px solid #201f1f;
}
.mini-cart li .total-price span {
    font-weight: 500;
    color: #201f1f;
}
.f-left {
    float: left;
}
.f-right {
    float: right;
}
.mini-cart li .checkout-link a {
    margin-bottom: 20px;
    /* width: 100%; */
} 
.os-btn {
    position: relative;
    display: inline-block;
    text-transform: uppercase;
    text-align: center;
    font-weight: 600;
    height: 50px;
    line-height: 46px;
    padding: 0 42px;
    border: 2px solid #ebebeb;
    color: #323232;
    background: transparent;
    z-index: 1;
    font-size: 12px;
}
.mini-cart li .checkout-link a:last-child {
    margin-bottom: 0;
}
.os-btn-black {
    color: #ffffff;
    background-color: #323232;
    border-color: #323232;
}
.os-btn-black::after {
    background-color: #bc8246;
}
.os-btn::after {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: 100%;
    height: 0;
    background-color: #bc8246;
    z-index: -1;
}
/* search */
.text-center {
    text-align: center!important;
}
.header__search {
    position: fixed;
    top: -100px;
    left: 0;
    width: 100%;
    min-height: 330px;
    padding: 40px 0;
    visibility: hidden;
    opacity: 0;
    -webkit-transform: scale(0.5);
    -moz-transform: scale(0.5);
    -ms-transform: scale(0.5);
    transform: scale(0.5);
    z-index: 9999;
}
.header__search.search-opened {
    top: 0;
    visibility: visible;
    opacity: 1;
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
}
.header__search-btn {
  margin-bottom: 35px;
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .header__search-btn {
    margin-bottom: 20px;
  }
}
@media (max-width: 575px) {
  .header__search-btn {
    margin-bottom: 20px;
  }
}
.header__search-btn-close {
  font-size: 18px;
  cursor: pointer;
  color: #bc8246;
}
.header__search-header {
  margin-bottom: 35px;
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .header__search-header {
    margin-bottom: 20px;
  }
  .vh80 {
    height: 550px;
  }
}
@media (max-width: 575px) {
  .header__search-header {
    margin-bottom: 20px;
  }
  .header__area{padding:10px 0}
  .header__action ul li > a{
    padding: 10px 0!important
  }
}
.header__search-header h3 {
  color: #323232;
  font-size: 30px;
}
.header__search-categories {
  margin-bottom: 35px;
}
.header__search-categories ul li {
  display: inline-block;
}
.header__search-categories ul li a {
  font-size: 18px;
  color: #323232;
  padding: 0 30px;
}
.header__search-categories ul li a:hover {
  color: #bc8246;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .header__search-categories ul li a {
    padding: 0 15px;
  }

}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .header__search-categories ul li a {
    font-size: 16px;
    padding: 0 5px;
  }
}
@media (max-width: 575px) {
  .header__search-categories ul li a {
    padding: 0 5px;
    font-size: 14px;
  }
}
.header__search-input input {
  height: 50px;
  width: 100%;
  border: none;
  padding: 0 15px;
  padding-right: 30px;
  border-bottom: 1px solid #ebebeb;
}
.header__search-input input::placeholder {
  color: #444;
}
.header__search-input input:focus {
  border-bottom-color: #bc8246;
}
.header__search-input button {
  position: absolute;
  top: 0;
  right: 0;
  height: 50px;
  width: 50px;
  text-align: center;
  font-size: 14px;
  background: transparent;
  color: #323232;
}
.point{cursor: pointer;}
.mega-menu>a{position: relative;}
.el-icon-arrow-down{position: absolute;right:0;top:50%;    transform: translate(0%, -100%);} 
.owl-carousel .w-img{display: inline-block;}
.side-mobile-menu p{margin-bottom: 0;}
.main-menu ul li.has-dropdown > a{font-size:16px}
.main-menu a{
  font-size: 16px;color:#292a30
}
.main-menu a p{
  font-size: 12px;color:#292a30;margin-bottom:0
}
.towmenu{background:#f5f5f5;margin:10px}
.main-menu ul li.mega-menu ul.submenu{
      width: 900px!important;
    left: -100px
  /* height:500px */
}
.transition-3{
  
  padding:10px
}
.transition-3 h5 a{
  font-size:16px!important; padding:10px 0!important; 
}

.banner__area .transition-3 h5 a{
  font-size:14px!important; padding:10px 0!important; 
}
.transition-3 h5 a span{
  font-size:12px!important; padding:5px 0!important; 
}
.towmenu  a{
  font-size:10px;
}
.link-btn {

    border: 1px solid #bc8246;
    border-radius: 20px;
    padding: 1px 2px!important;
    white-space: nowrap;
    text-transform: none;
}
.towmenuleft .link-btn{
  width:fit-content!important;
  font-size:16px!important;
   padding: 5px 20px!important;
}
 .w-img {height:310px}
 .w-img img{height:100%}
 .logourl a img{height:70px}
 @media (max-width: 1200px) {
           .w-img {height:255px}
}   
      
@media (max-width: 990px) {
    
     .w-img {height:390px}
}
@media (min-width:480px) and (max-width:767px) {
    .w-img{
        height:285px
    }
   
}
@media (max-width: 488px) {
    .w-img{
        height:200px
    } 
}
@media (min-width:375px) and (max-width:400px) {
    .logourl a img{height:50px}
    .w-img{
        height:180px
    }
}
#scrollback a {
    position: fixed;
    left: 15px;
    top: 85px;
    width: 40px;
    height: 40px;
    /* line-height: 40px; */
    text-align: center;
    font-size: 15px;
    color: #ffffff;
    list-style-type: none;
    /* background: #bc8246; */
    margin-right: 20px;
    /* border: 1px solid #bc8246; */
    z-index: 999;
}
#scrollback a img {
  width: 100%;height:100%;
}
.towmenucolor{background:transparent}
.towmenuleft h2 a{font-size: 36px!important;}
.scrollx {bottom: 70px !important;background-color: #000!important;border: 1px solid #000!important;}
.scrollx p{line-height:12px;font-size: 12px;margin:0;margin-top:2px;}
/* search */

</style>



// WEBPACK FOOTER //
// src/components/header.vue